import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(() => ({
  fallbackContainer: {
    opacity: 0.6,
    justifyContent: "center",
    alignItems: "center",
  },
  fallbackImage: {
    width: "80%",
    height: "80%",
  },
}));

export default stylesheet;
